import { GetterTree } from 'vuex'
import store from './'

const getters: GetterTree<any, any> = {
	currentStatementId(state): number {
		return state.currentStatementId
	},
	choices(state): [] {
		return state.choices
	},
	graphSeenOnStatement(state): boolean[] {
		return state.graphSeenOnStatement
	},
	resultsSeenSinceLastChange(state): boolean {
		return state.resultsSeenSinceLastChange
	},
	resultsSeenSinceStart(state): boolean {
		return state.resultsSeenSinceStart
	}
}

export default getters
